import MobileMain from '@/apps/mobile/components/MobileMain';
import MobileLocationList from '@/apps/mobile/components/MobileLocationList';
import MobileLocation from '@/apps/mobile/components/MobileLocation';
import MobileSignIn from '@/apps/mobile/components/MobileSignIn';
import MobileSelectLocation from '@/apps/mobile/components/MobileSelectLocation';
import MobileMenu from '@/apps/mobile/components/MobileMenu';
import MobilePastOrders from '@/apps/mobile/components/MobilePastOrders';
import MobileConfigurator from '@/apps/mobile/components/MobileConfigurator';
import MobileUserAccount from '@/apps/mobile/components/MobileUserAccount';
import MobileUserAccountEditor from '@/apps/mobile/components/MobileUserAccountEditor';
import MobilePaymentConfirm from '@/apps/mobile/components/MobilePaymentConfirm';
import MobileOrderConfirmation from '@/apps/mobile/components/MobileOrderConfirmation';
import SignIn from '@/apps/auth/components/SignIn';
import Login from '@/apps/auth/components/Login';
import ForgotPassword from '@/apps/auth/components/ForgotPassword';
import ClaimAccount from '@/apps/auth/components/ClaimAccount';
import MobileCart from '@/apps/mobile/components/MobileCart';
import MobileFriesMenu from '@/apps/mobile/components/MobileFriesMenu';
import MobileKidsMenu from '@/apps/mobile/components/MobileKidsMenu';
import MobileLazyMenu from '@/apps/mobile/components/MobileLazyMenu';
import GuestCheckout from '@/apps/mobile/components/GuestCheckout';

const routes = [
  // Alias for mobile-main. So as not to remove the original in order to avoid possible breaking changes
  {
    name:      'main',
    path:      '/',
    component: MobileMain,
  },
  {
    path:      '/',
    name:      'mobile-main',
    component: MobileMain,
  },
  {
    path:      '/locations',
    name:      'locations',
    component: MobileLocationList,
  },
  {
    path:      '/location/:restId',
    name:      'location-detail',
    component: MobileLocation,
    props:     true,
  },
  {
    path:      '/join-sign-in',
    component: MobileSignIn,
    props:     route => ({
      checkoutAfterLogin: String(route.query.checkoutAfterLogin) === 'true',
    }),
    children: [
      {
        path:      '',
        name:      'join-sign-in',
        component: SignIn,
        meta:      { title: 'Join / Sign In' },
        props:     route => ({
          checkoutAfterLogin: String(route.query.checkoutAfterLogin) === 'true',
        }),
      },
      {
        path:      'claim-account',
        name:      'claim-account',
        component: ClaimAccount,
        meta:      { title: 'Claim Account' },
        props:     route => ({
          checkoutAfterLogin: String(route.query.checkoutAfterLogin) === 'true',
        }),
      },
      {
        path:      'login',
        name:      'login',
        component: Login,
        meta:      { title: 'Login', welcomeText: true },
        props:     route => ({
          checkoutAfterLogin: String(route.query.checkoutAfterLogin) === 'true',
        }),
      },
      {
        path:      'forgot-password',
        name:      'forgot-password',
        component: ForgotPassword,
        meta:      { title: 'Forgot Password' },
      },
    ],
  },
  {
    path:      '/guest-checkout',
    name:      'guest-checkout',
    component: GuestCheckout,
    meta:      { title: 'Guest Checkout' },
  },
  {
    path:      '/new-order/select-location',
    name:      'new-order-select-location',
    component: MobileSelectLocation,
    props:     { nextRouteName: 'menu' },
  },
  {
    path:      '/past-order/select-location',
    name:      'past-order-select-location',
    component: MobileSelectLocation,
    props:     { nextRouteName: 'past-orders' },
  },
  {
    path:      '/past-orders/',
    name:      'past-orders',
    component: MobilePastOrders,
  },
  {
    path:      '/menu',
    name:      'menu',
    component: MobileMenu,
  },
  {
    path:      '/configurator/:id',
    name:      'configurator',
    component: MobileConfigurator,
  },
  {
    path:      '/user-profile',
    name:      'user-profile',
    component: MobileUserAccount,
  },
  {
    path:      '/edit-user-profile',
    name:      'edit-user-profile',
    component: MobileUserAccountEditor,
    meta:      { redirectIfCancel: { name: 'user-profile' } },
    props:     route => ({
      checkoutAfterLogin: String(route.query.checkoutAfterLogin) === 'true',
    }),
  },
  {
    path:      '/create-account',
    name:      'create-account',
    component: MobileUserAccountEditor,
    meta:      { title: 'New Account',  isNewAccount: true, redirectIfCancel: { name: 'mobile-main' } },
    props:     route => ({
      checkoutAfterLogin: String(route.query.checkoutAfterLogin) === 'true',
    }),
  },
  {
    path:      '/payment-confirm',
    name:      'payment-confirm',
    component: MobilePaymentConfirm,
    props:     route => ({
      backPage: route.query.backPage,
    }),
  },
  {
    path:      '/order-confirmation',
    name:      'order-confirmation',
    component: MobileOrderConfirmation,
  },
  {
    path:      '/cart',
    name:      'cart',
    component: MobileCart,
  },
  {
    path:      '/fries-menu',
    name:      'fries-menu',
    component: MobileFriesMenu,
  },
  {
    path:      '/kids-menu',
    name:      'kids-menu',
    component: MobileKidsMenu,
  },
  {
    path:      '/lazy-menu',
    name:      'lazy-menu',
    component: MobileLazyMenu,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/apps/mobile/router/index.js